module.exports = __webpack_public_path__ + "static/media/image-draw.66447bf1.svg";